import React from 'react';
import '../styles/myth-division.css';

const MythDivision = () => {
  return (
    <div className="myth-container">
      <div className="myth-noise-overlay"></div>
      <div className="myth-gradient-overlay"></div>
      
      <main className="myth-content">
        {/* Top Label */}
        <header className="myth-header">
          <span className="myth-label">
            <span className="myth-label-bold">MYTH</span> DIVISION
          </span>
        </header>

        {/* Main Content */}
        <section className="myth-main">
          {/* MD Logo */}
          <img 
            src="https://customer-assets.emergentagent.com/job_678e4ccc-0342-47ab-b09c-8ee24f0cc4a1/artifacts/ryesrjk1_Myth%20Division%20Initials%20Logo%20white%20ang%20black%20-v3.png" 
            alt="Myth Division Logo" 
            className="myth-logo"
          />
          
          {/* Main Headline */}
          <h1 className="myth-headline">
            <span className="myth-headline-line">Between Chapters.</span>
            <span className="myth-headline-line">Between Worlds.</span>
          </h1>

          {/* Supporting Copy */}
          <div className="myth-supporting">
            <p className="myth-copy myth-copy-intro">
              Sometimes it is visible. Sometimes it is not.
            </p>
            
            <div className="myth-copy-block">
              <p className="myth-copy">We are offline by design.</p>
            </div>
            
            <p className="myth-copy myth-copy-final">
              Next Announcement Scheduled Q2 2026
            </p>
          </div>
        </section>

        {/* Footer removed - content moved to main body */}
      </main>
    </div>
  );
};

export default MythDivision;
